module.exports = __webpack_public_path__ + "img/PA282499.63cb7f31.jpg";